import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=0e680c6c"
import script from "./RegionList.vue?vue&type=script&lang=js"
export * from "./RegionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e680c6c')) {
      api.createRecord('0e680c6c', component.options)
    } else {
      api.reload('0e680c6c', component.options)
    }
    module.hot.accept("./RegionList.vue?vue&type=template&id=0e680c6c", function () {
      api.rerender('0e680c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/RegionList.vue"
export default component.exports